import { useQuery } from '@tcs/common/hooks/useQuery';
import { AccountSearchResult } from '@tcs/client-portal-api/types/AccountSearchResult';

interface Props {
  loading: boolean;
  data?: AccountSearchResult[];
}

export const useRepresentativeAccounts = (
  representativeCode,
  options?: { enabled: boolean }
): Props => {
  const { data, isLoading: loading } = useQuery<AccountSearchResult[], Error>(
    `/representatives/${representativeCode}/accounts`,
    options
  );
  return {
    loading,
    data,
  };
};

export default useRepresentativeAccounts;
